<template>
    <v-layout column>
        <v-flex v-if="hasPlans" xs12 class="my-3">
            <app-membership-offer :to="ctaPath" :hide-button="!ctaPath"></app-membership-offer>
            <p v-if="!$auth.check()" class="_free-note">
                Not ready to join today? <router-link to="/signup?role=parent">Create a Free Account</router-link>
                to browse NannyGrannies in your area.
            </p>
        </v-flex>
    </v-layout>
</template>

<script>
import { DEFAULT_SIGNUP_OPT,MAIN_SIGNUP_PLANS_OPT } from '../../config/constants'
import AppMembershipOffer from '../app-membership/app-membership-offer'
  export default {
    components: {AppMembershipOffer},
    name: 'app-btn-toggle-plan-reg',
    filters: {
      savePer: function (item) {
        return (100 - parseInt(parseFloat(item.price_all) * 100 / parseFloat(item.price)))
      }
    },

    props: {
      value: Number,
      showvalidplans: null,
      mandatory: {
        type: Number,
        default: 1
      },
      hideDescription: Boolean
    },

    data () {
        
      return {
        select: null,
        default_signup_method: DEFAULT_SIGNUP_OPT,
        //show_signup_method: showvalidplans,
      }
    },

    computed: {
      // Guests go to signup, logged-in Free Customers to their Membership page; nobody else needs the CTA
      ctaPath () {
        if (!this.$auth.check()) return '/signup?role=parent'
        const user = this.$auth.user()
        return user.role === 'parent' && user.subscription && user.subscription.ended ? '/subscription' : null
      },
        
      hasPlans () {
        return this.$store.getters['subscription/hasPlans']
      },
     
      plans () {
        console.log("default_signup_method = "+this.default_signup_method);
        let plans= this.$store.getters['subscription/plans']
        if (typeof this.showvalidplans !== 'undefined') {
            console.log(" find the value of default_signup_method");
          const matchedElements = plans.filter(item1 => {
            return this.showvalidplans.find(item2 => item2 === item1.id);
          });
          console.log("showvalidplans= "+this.showvalidplans);
          console.log("matchedElements= "+matchedElements);
          return matchedElements
        }
        else{
            console.log(" find the value of default_signup_method else");
            const matchedElements = plans.filter(item1 => {
            return this.default_signup_method.find(item2 => item2 === item1.id);
            });
            console.log("matchedElements else= "+matchedElements);
            return matchedElements
        }

        
      }
    },

    watch: {
    
      select () {
       
        this.$store.commit('subscription/SET_PLAN', this.select)
        if (this.select) {
          this.$emit('input', this.select.id)
        }
      },
      currentPlan (plan) {
        let price = this.$lodash.get(plan, 'price_all', 0)
        this.form.summ = price ? price : this.$lodash.get(plan, 'price', 0)
      }
    },

    mounted () {
        
      if (this.hasPlans) {
        this.select = this.plans[this.mandatory]
      }
    },

    methods: {
        
      isSave: function (item) {
        return parseInt(item.price) !== parseInt(item.price_all) && !isNaN(item.price_all) && parseInt(item.price_all) > 0
      },
      submit (plan_id) {
        let plans =  this.$store.getters['subscription/plans']
        console.log(plans);
        var i;
        plans.forEach(function(x, index) {
            if (x.id == plan_id) {
                i = index;
            }
        });
        this.$store.commit('subscription/SET_PLAN', plans[i])
         this.$store.dispatch('register/STEP_2', {data: this.user})
          .then(() => (this.$router.push('/signup/step-3/parent')))
          .catch(error => (console.log(error)))
      },
      submitfree () {
        this.$router.push('/signup/step-3/parent-free')
      }
    }
  }
</script>

<style lang="stylus" scoped>
    ._free-note
        margin 16px 0 0
        font-size 14px
        text-align center
</style>



// WEBPACK FOOTER //
// src/components/app-buttons/app-btn-toggle-plan.vue